import styled from 'styled-components'
import classNames from 'classnames'

const TextBreakWrapper = styled.span`
	display: block;
`

export const TextBreak: React.FC<{ customClassName?: string }> = ({ customClassName }) => {
	return <TextBreakWrapper className={classNames('text-break', customClassName)} />
}
